import CityPageTemplate from "../city-template/CityPageTemplate";
import { nicholasvilleConfig } from "./data";

export default function NicholasvillePage() {
  return <CityPageTemplate config={nicholasvilleConfig} />;
}